import React from 'react';
import { StaticQuery, graphql } from "gatsby";
import { Link } from "gatsby"
import module from '../../gatsby-config.js';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);

    this.state = {
      isOpen: false,
      title: props.data.markdownRemark.frontmatter.title,
      chapter_string: props.data.markdownRemark.frontmatter.chapter_string,
      archive_string: props.data.markdownRemark.frontmatter.archive_string,
      interview_string: props.data.markdownRemark.frontmatter.interview_string,
      interview_link: props.data.markdownRemark.frontmatter.interview_link,
      references_string: props.data.markdownRemark.frontmatter.references_string,
      references_link: props.data.markdownRemark.frontmatter.references_link,
      chapters: props.data.markdownRemark.frontmatter.chapters,
      archives: props.data.markdownRemark.frontmatter.archives,
    };

  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {

    const chapterItems = this.state.chapters.map(function (chapter, key){

	 var doDropdowns = function(list, targetContainer, targetDropdown){
		 var containers = list.parentElement.getElementsByClassName('dropdown');

		 if(targetContainer.classList.contains("dropdown")){

			 for (var i = 0; i < containers.length; i++){
				 var item = containers[i];
				 var dropdown = item.getElementsByTagName('div')[0];

				 item.classList.remove("show");
	    		 item.setAttribute("aria-expanded", false);

	    		 dropdown.classList.remove("show");
	    		 dropdown.setAttribute("aria-hidden", true);
			 }
			 targetContainer.classList.add("show");
			 targetContainer.setAttribute("aria-expanded", true);
			 targetDropdown.classList.add("show");
			 targetDropdown.setAttribute("aria-hidden", false);
	 	}
	 }

	 /*var onMouseEnter = function(e){
		 var anchor = e.target;
		 var container = anchor.parentElement;
		 var dropdown = container.getElementsByTagName('div')[0];
		 doDropdowns(container.parentElement, container, dropdown);
	 }*/

	  var onMouseLeaveMenu = function(e){
		  var dropdown = e.target;
		  var container = dropdown.parentElement;

		  container.classList.remove("show");
		  container.setAttribute("aria-expanded", false);

		  dropdown.classList.remove("show");
		  dropdown.setAttribute("aria-hidden", true);
	  }

      return(
        <UncontrolledDropdown nav inNavbar key={key}>
          <DropdownToggle nav caret>
            {chapter.title}
          </DropdownToggle>
          <DropdownMenu className={key > 3 ? "dropdown-menu-right" : ""} style={{ maxHeight:"170px", minWidth:"400px", maxWidth:"400px", overflowX: "hidden", overflowY: "scroll"}} onMouseLeave={onMouseLeaveMenu}>
          {chapter.pages.map(function (page, k){
            var chapterKey = "ch" + key + "_pg" + k;

			var front = page.page_title;
			var back = "";
			if(page.page_title.length >= 35){
				var bestSpaceIdx = page.page_title.substring(0,34).lastIndexOf(' ');
				front = page.page_title.substring(0,bestSpaceIdx);
				back = page.page_title.substring(bestSpaceIdx+1);
			}

            return(
            <DropdownItem key={chapterKey}>
              <NavItem>
                 {back !== "" ? <NavLink href={module.pathPrefix + page.page_link}>{front}<br /> {back}</NavLink> : <NavLink href={module.pathPrefix + page.page_link}>{front}</NavLink>}
              </NavItem>
            </DropdownItem>
          )})}
          </DropdownMenu>
        </UncontrolledDropdown>
    )});

	/*var onMouseEnterRight = function(e){
		var anchor = e.target;
		var container = anchor.parentElement;
		var dropdown = container.getElementsByTagName('div')[0];
		doDropdownsRight(container.parentElement, container, dropdown);
	}*/

	 var doDropdownsRight = function(list, targetContainer, targetDropdown){
		var containers = list.parentElement.getElementsByClassName('dropdown');

		if(targetContainer.classList.contains("dropdown")){

			for (var i = 0; i < containers.length; i++){
				var item = containers[i];
				var dropdown = item.getElementsByTagName('div')[0];

				item.classList.remove("show");
				item.setAttribute("aria-expanded", false);

				dropdown.classList.remove("show");
				dropdown.setAttribute("aria-hidden", true);
			}
			targetContainer.classList.add("show");
			targetContainer.setAttribute("aria-expanded", true);
			targetDropdown.classList.add("show");
			targetDropdown.setAttribute("aria-hidden", false);
	   }
	}

    const archiveItems = this.state.archives.map(function (archive, key){
      var archiveKey = "arc" + key;
      return (<Link key={archiveKey} to={archive.link} className="nav-link">{archive.title}</Link>);
    });

	var onMouseLeaveNavbarRight = function(e){
		var containers = e.target.getElementsByClassName('dropdown');
		for (var i = 0; i < containers.length; i++){
			var item = containers[i];
			var dropdown = item.getElementsByTagName('div')[0];

			item.classList.remove("show");
			item.setAttribute("aria-expanded", false);

			dropdown.classList.remove("show");
			dropdown.setAttribute("aria-hidden", true);
		}
	}

	var onMouseLeaveMenuRight = function(e){
		var dropdown = e.target;
		var container = dropdown.parentElement;

		container.classList.remove("show");
		container.setAttribute("aria-expanded", false);

		dropdown.classList.remove("show");
		dropdown.setAttribute("aria-hidden", true);
	}


    return (
        <Navbar sticky="top" color="light" light expand="lg" position="fixed" style={{borderBottom:"1px solid black"}}>
          <Link to="/" className="navbar-brand">{this.state.title}</Link>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="mr-auto" style={{paddingTop: "12px"}} navbar>

                    {chapterItems}
				<NavItem>
				  <Link key={this.state.references_link} to={this.state.references_link} className="nav-link">{this.state.references_string}</Link>
				</NavItem>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    {this.state.archive_string}
                  </DropdownToggle>
                  <DropdownMenu right style={{ maxHeight:"170px", minWidth:"400px", maxWidth:"400px", overflowX: "hidden", overflowY: "scroll"}} onMouseLeave={onMouseLeaveMenuRight}>
                    <DropdownItem>
                      <NavItem>
                        {archiveItems}
                      </NavItem>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>

              <NavItem>
                <Link key={this.state.interview_link} to={this.state.interview_link} className="nav-link">{this.state.interview_string}</Link>
              </NavItem>

              </Nav>
            </Collapse>
          </Navbar>
    );
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      query navigation {
        markdownRemark(frontmatter: {navbar: {eq: "Navbar"}}) {
          frontmatter {
            title
            navbar
            chapter_string
            archive_string
            interview_string
            interview_link
			references_string
			references_link
            chapters {
              title
              pages{
                page_title
                page_link
              }
            }
            archives {
              link
              title
            }
          }
        }
      }`}
    render={data => <Navigation data={data} {...props} />}
  />
)
